'use strict';

var contentloader = {
    init: function () {
        var loadContainers = document.getElementsByClassName('loadContainer');
        for (var i = 0; i < loadContainers.length; i++) {
            var container = loadContainers[i];
            var delay = container.dataset.delay || 100;
            var url = container.dataset.url || '';
            if (url) {
                // eslint-disable-next-line
                setTimeout(function () {
                    $(container).load(url);
                }, delay);
            }
        }
    }
};

module.exports = contentloader;
